type WorkstationAmenityLike = {
  description?: string | null;
  iconName?: string | null;
};

type AmenityDisplay = {
  label: string;
  filterIconName: string;
  filterSvgIconName?: string;
  tableIconName: string;
};

const monitorIconName = 'desktop_windows';
const dualMonitorSvgIconName = 'material:dual-monitor';

const monitorOneDisplay: AmenityDisplay = {
  label: 'Monitor #1',
  filterIconName: monitorIconName,
  tableIconName: monitorIconName,
};

const monitorTwoDisplay: AmenityDisplay = {
  label: 'Monitor #2',
  filterIconName: '',
  filterSvgIconName: dualMonitorSvgIconName,
  tableIconName: monitorIconName,
};

const amenityDisplayByDescription = new Map<string, AmenityDisplay>([
  ['monitor', monitorOneDisplay],
  ['monitor #1', monitorOneDisplay],
  ['dual monitor', monitorTwoDisplay],
  ['dual monitors', monitorTwoDisplay],
  ['double monitor', monitorTwoDisplay],
  ['2 monitors', monitorTwoDisplay],
  ['monitor #2', monitorTwoDisplay],
  [
    'docking station',
    { label: 'Docking station', filterIconName: 'dock_to_bottom', tableIconName: 'dock_to_bottom' },
  ],
  [
    'docking stations',
    { label: 'Docking station', filterIconName: 'dock_to_bottom', tableIconName: 'dock_to_bottom' },
  ],
  [
    'dock',
    { label: 'Docking station', filterIconName: 'dock_to_bottom', tableIconName: 'dock_to_bottom' },
  ],
  ['mouse', { label: 'Mouse', filterIconName: 'mouse', tableIconName: 'mouse' }],
  ['keyboard', { label: 'Keyboard', filterIconName: 'keyboard', tableIconName: 'keyboard' }],
  [
    'height adjustable desk',
    { label: 'Sit-Stand desk', filterIconName: 'height', tableIconName: 'height' },
  ],
  [
    'sit-stand desk',
    { label: 'Sit-Stand desk', filterIconName: 'height', tableIconName: 'height' },
  ],
  [
    'sit stand desk',
    { label: 'Sit-Stand desk', filterIconName: 'height', tableIconName: 'height' },
  ],
]);

export function getWorkstationAmenityLabel(
  amenity: WorkstationAmenityLike | null | undefined
): string {
  const display = getAmenityDisplay(amenity);
  return display?.label ?? amenity?.description ?? '';
}

export function getWorkstationAmenityFilterIconName(
  amenity: WorkstationAmenityLike | null | undefined
): string {
  const display = getAmenityDisplay(amenity);
  return display?.filterIconName ?? amenity?.iconName ?? '';
}

export function getWorkstationAmenityFilterSvgIconName(
  amenity: WorkstationAmenityLike | null | undefined
): string {
  const display = getAmenityDisplay(amenity);
  return display?.filterSvgIconName ?? '';
}

export function getWorkstationAmenityTableIconName(
  amenity: WorkstationAmenityLike | null | undefined
): string {
  const display = getAmenityDisplay(amenity);
  return display?.tableIconName ?? amenity?.iconName ?? '';
}

function getAmenityDisplay(
  amenity: WorkstationAmenityLike | null | undefined
): AmenityDisplay | null {
  const description = amenity?.description?.trim().toLowerCase();
  if (!description) {
    return null;
  }

  return amenityDisplayByDescription.get(description) ?? null;
}
